if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

        $('.book-now').on('click', function(e) {
            e.preventDefault();
            var destinationUrl = $(this).attr('href');  
            ga(function(tracker) {
                   var linker = new window.gaplugins.Linker(tracker);
                 var output = linker.decorate(destinationUrl, true);
                 ga('send', 'event', 'reservations', 'click', 'book now');
                 window.open(output, '_blank');
                 }); 
        }); 
        
        
        $('.book-now-main').on('click', function(e) {
            e.preventDefault();
            var destinationUrl = $(this).attr('href');  
            ga(function(tracker) {
                    var linker = new window.gaplugins.Linker(tracker);
                    var output = linker.decorate(destinationUrl, true);
                    ga('send', 'event', 'reservations', 'click', 'book now');
                    window.open(output, '_blank');
                }); 
        }); 

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let tabSelector = document.querySelectorAll('li.tabSelector')
    const setActive = el => {
        [...el.parentElement.children].forEach(sib => sib.classList.remove('active'))
        el.classList.add('active')
    }
    tabSelector.forEach(function(elem) {
        elem.addEventListener("click", function() {
            let slideno = this.getAttribute('data-index');
            $('.tabs-location__tabs--content-items').slick('slickGoTo', slideno);
            setActive(elem);
        });
    });
    $('.tabs-location__tabs--content-items').slick({
        dots: false,
        fade: true,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              dots:true,
              arrows:true
            }
          }
        ]
      });
    $(".tabs-location__tabs--content-items").on("afterChange", function(a, e, i, l) {
        $(".tabs-location__tabs--tabs ul li").removeClass("active");
        $(".tabs-location__tabs--tabs ul li:eq(" + i + ") ").addClass("active");
    });
    
})();